import { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as styles from './styles';
import { currency, currencyNameToSymbol } from 'services/currency';
import { isIE } from 'services/functions';
import * as invoiceActions from '../../reducer/invoiceActions';

// Services
import { numbersToLocaleString, localStringToNumbers } from '../../services';

// Components
import CheckBoxField from 'components/Fields/CheckBoxField';
import CustomServiceModal from '../CustomServiceModal/CustomServiceModal';
import InputPrice from '../InputPrice';

const splitName = name => {
  const nameToArray = String(name).split(' ');
  return (
    <div>{nameToArray.map((text, index) => <span key={`${text}-${index}`}>{text} </span>)}</div>
  );
};

const generateServiceKey = el => {
  if (el.serviceId) {
    return el.serviceId;
  }
  if (el.name) {
    return `${el.name}-${new Date().getTime()}`;
  }
};

const cloneObj = obj => {
  return obj && typeof obj === 'object' ? JSON.parse(JSON.stringify(obj)) : null;
};

class IncludedServicesInInvoice extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isProDeo: false,
      customServiceModalIsOpen: false,
      editPriceItem: null,
      newInvoice: cloneObj(props.invoice.activeServices)
    };
    this.addCustomService = this.addCustomService.bind(this);
    this.handlerSubmit = this.handlerSubmit.bind(this);
    this.onChangeProDeo = this.onChangeProDeo.bind(this);
    this.onInputItemPrice = this.onInputItemPrice.bind(this);
    this.triggerCustomServiceModal = this.triggerCustomServiceModal.bind(this);
  }

  componentDidUpdate(prevProps) {
    const {
      invoice: { activeServices }
    } = this.props;
    const { newInvoice } = this.state;
    const cloneNewInvoices = cloneObj(activeServices);
    if (JSON.stringify(activeServices) !== JSON.stringify(prevProps.invoice.activeServices)) {
      cloneNewInvoices.map(el => {
        const x = newInvoice.find(ser => ser.serviceId === el.serviceId);
        let price;
        if (x) {
          price = parseFloat(localStringToNumbers(x.price), 10).toFixed(2);
        } else {
          price = parseFloat(el.price, 10).toFixed(2);
        }
        el.price = numbersToLocaleString(price);
        return el;
      });
      this.setState({ newInvoice: cloneNewInvoices });
    }
  }

  handlerSubmit() {
    const { params, invoice, invoiceActions } = this.props;
    const { newInvoice } = this.state;
    const newInvoiceWithCorrectPrice = Array.isArray(newInvoice)
      && newInvoice.map(el => {
        if (el.price) el.price = Number(localStringToNumbers(el.price));
        return el;
      });

    // update
    if (params.invoiceId && newInvoiceWithCorrectPrice.length) {
      const invoiceData = {
        invoiceId: invoice.currentInvoice.id,
        appointmentId: invoice.currentInvoice.externalAppointment.externalId,
        rowVersion: invoice.currentInvoice.rowVersion
      };

      const servicesWithId = newInvoiceWithCorrectPrice.map(s => {
        if (
          invoice.currentServices &&
          invoice.currentServices.length &&
          invoice.currentServices.find(i => i.serviceId === s.serviceId)
        ) {
          s.id = s.serviceId;
        }
        s.price = Number(s.price);
        return s;
      });

      invoiceActions.updateInvoiceServices(invoiceData, servicesWithId, this.state.isProDeo);
      return;
    }
    // create new
    if (newInvoice.length) {
      invoiceActions.saveNewInvoice(
        params.appointmentId,
        newInvoiceWithCorrectPrice,
        this.state.isProDeo
      );
    }
  }

  onChangeProDeo() {
    const { isProDeo } = this.state;
    this.setState({ isProDeo: !isProDeo });
  }

  //──── Price input ───────────────────────────────────────────────────────────────────────
  onInputItemPrice(serviceId, value, disableEdit) {
    const clone = Object.assign({}, this.state);
    clone.newInvoice.map(el => {
      if (el.serviceId === serviceId) {
        el.price = value;
      }
      return el;
    });
    if (disableEdit) {
      clone.editPriceItem = null;
    }
    this.setState(clone);
  }

  // ──── Modal ─────────────────────────────────────────────────────────────────────────────
  triggerCustomServiceModal() {
    this.setState({
      customServiceModalIsOpen: !this.state.customServiceModalIsOpen
    });
  }

  addCustomService(customService) {
    customService.serviceId = `${customService.name}-${customService.price}`;
    customService.price = Number(parseFloat(customService.price).toFixed(2));
    this.props.invoiceActions.addActiveService(customService);
  }

  render() {
    const { i18n, invoiceActions } = this.props;
    const { customServiceModalIsOpen, editPriceItem, newInvoice, isProDeo } = this.state;
    const inputWidth = (value, item) => {
      const length = String(value).length;
      return currentItemIsEdited(item) ? length + (isIE ? 4 : 2) : length - (isIE ? -1 : 0);
    };

    const currentItemIsEdited = item => editPriceItem === item.serviceId;

    const amount = newInvoice
      ? newInvoice.reduce((state, item) => {
        state = currency(state).add(parseFloat(localStringToNumbers(item.price), 10) || 0);
        return state;
      }, 0)
      : 0;

    return (
      <styles.CreateInvoiceBlock>
        {/* ──── Header ───────────────────────────────────────────────────────────────────── */}

        <styles.InvoiceHeader>
          <styles.HeaderTitle>{i18n.t('selected_items')}</styles.HeaderTitle>
          <styles.HeaderTitle float="right">{i18n.t('price')}</styles.HeaderTitle>
        </styles.InvoiceHeader>

        {/* ──── List ──────────────────────────────────────────────────────────────────────── */}

        {newInvoice.length ? (
          <styles.InvoiceList>
            <styles.InvoiceListContent>
              {newInvoice.map(item => {
                return (
                  <styles.Invoice key={generateServiceKey(item)}>
                    <styles.DeleteInvoice onClick={() => {
                      invoiceActions.removeActiveService(item);
                    }} />
                    <styles.DescriptionWrapper>
                      <styles.DescriptionBlock>
                        {splitName(item.name)}

                        <styles.CostBlock edited={currentItemIsEdited(item)}>
                          <span hidden={currentItemIsEdited(item)}>
                            {currencyNameToSymbol('eur')}
                          </span>
                          <div>
                            <InputPrice
                              value={numbersToLocaleString(item.price)}
                              style={{
                                width: `${inputWidth(item.price, item)}ch`
                              }}
                              onFocus={() => {
                                this.setState({ editPriceItem: item.serviceId });
                              }}
                              onBlur={value => {
                                this.onInputItemPrice(item.serviceId,
                                  numbersToLocaleString(value), true);
                              }}
                            />
                          </div>
                        </styles.CostBlock>
                      </styles.DescriptionBlock>
                      <styles.DescriptionNumber>{item.nomenclature}</styles.DescriptionNumber>
                    </styles.DescriptionWrapper>
                  </styles.Invoice>
                );
              })}

              {/* ──── Add custom item btn ─────────────────────────────────────────────────── */}

              <styles.AddNewItemsBtn onClick={this.triggerCustomServiceModal}>
                {i18n.t('custom_item_open_modal_btn')}
              </styles.AddNewItemsBtn>
            </styles.InvoiceListContent>
          </styles.InvoiceList>
        ) : (
          <styles.WrapperEmpty>
            <styles.EmptyInvoiceList>
              <styles.NoInvoicesIcon />
              <styles.NoInvoiceTitle>
                {i18n.t('placeholder_no_items_selected')}
              </styles.NoInvoiceTitle>
            </styles.EmptyInvoiceList>
          </styles.WrapperEmpty>
        )}

        {/* ──── Total ──────────────────────────────────────────────────────────────────────── */}

        <styles.TotalBlock>
          <div>
            <span>{i18n.t('total')}</span>
            <span>{currency(amount).format()}</span>
          </div>
        </styles.TotalBlock>

        {/* ──── Create/Edit btn ────────────────────────────────────────────────────────────── */}
        <styles.ProDeoBlock>
          <CheckBoxField
            input={{
              value: isProDeo,
              onChange: this.onChangeProDeo
            }}
            rightLabel={i18n.t('check-box_prodeo')}
            textStyle={{ fontSize: '16px', whiteSpace: 'nowrap' }}
          />
        </styles.ProDeoBlock>

        <div style={{ textAlign: 'center', display: 'flex' }}>
          <styles.CreateInvoiceBtn disabled={!newInvoice.length} onClick={this.handlerSubmit}>
            {i18n.t('create_invoice')}
          </styles.CreateInvoiceBtn>
        </div>

        {/* ──── Modals ──────────────────────────────────────────────────────────────────────── */}
        <CustomServiceModal
          isOpen={customServiceModalIsOpen}
          i18n={i18n}
          closeModal={this.triggerCustomServiceModal}
          onSubmit={this.addCustomService}
        />
      </styles.CreateInvoiceBlock>
    );
  }
}

const mapStateToProps = state => ({
  invoice: state.practitioner.invoice
});

const mapDispatchToProps = dispatch => ({
  invoiceActions: bindActionCreators(invoiceActions, dispatch)
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(IncludedServicesInInvoice);
